import { render } from "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=template&id=e15b693c&scoped=true"
import script from "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=script&lang=js"

import "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=style&index=0&id=e15b693c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15b693c"]])

export default __exports__